/** @jsxImportSource @emotion/react */

import {css} from "@emotion/react";
import LoadingScreen from "components/LoadingScreen";
import {useState} from "react";
import { useParams } from "react-router-dom"; 

// Default URL that can be overridden by environment variables
const DEFAULT_OFAC_URL = "https://ofac.qa.aeiglabs.com/";
const ofacUrlBase = process.env.REACT_APP_OFAC_URL || DEFAULT_OFAC_URL; 

export default function OFACSearch() {
  const [loading, setLoading] = useState(true);
  const { detailsID } = useParams<{ detailsID?: string }>(); 

  // Construct the iframe source URL
  let iframeSrc = ofacUrlBase;
  if (detailsID) {
    // Ensure the base URL ends with a slash if it doesn't already
    const baseUrl = ofacUrlBase.endsWith('/') ? ofacUrlBase : `${ofacUrlBase}/`;
    iframeSrc = `${baseUrl}details/${detailsID}`;
  }

  return (
    <div>
      {loading && <LoadingScreen />}
      <iframe
        title="OFAC Search"
        src={iframeSrc} 
        css={css`
          border: none;
          height: calc(100vh - 64px);
          width: 100%;
        `}
        onLoad={() => setLoading(false)}
      />
    </div>
  );
}
